// ##############################
// // // Login state and Wordpress connection
// #############################
import React, { createContext } from "react";
import Storage from "classes/Storage.jsx";
//import Push from "classes/Push.jsx";

let wbStorage = new Storage();
//let wbPush = new Push();

class Session {
    constructor() {
        this.logging = false;
        
        this.url = process.env.API_URL;
        this.apikey = process.env.API_KEY;
        
        this.session_id = null;
        this.session_key = null;
        this.user_id = null;
        this.username = 'Admin';
        this.app_id = 0;
        this.app_pwd = null;
        // this.push_key = null;
        this.sessionError = function(e){};
        this.profileLoaded = function(profile){};
        this.is_logging_in = false;
        
        this.restoreSession();
    }
    
    /**
     * Perform a login with username/password and set this.session_id and this.user_id
     */
    login = async ( user, pass ) => {
        if( this.logging ) console.log('Attempting login');
        this.is_logging_in = true;
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'login',
        };
        const bodyParams = {
            username: user,
            password: pass,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                body: JSON.stringify(bodyParams),
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        
        if( ret.success && ret.session ){
            if( this.logging ) console.log('Login success! Saving session.');
            this.session_id = ret.session.s_id;
            this.session_key = ret.session.s_key;
            if( ret.session.user_id ){
                this.user_id = ret.session.user_id;
            }
            if( ret.username ){
                this.username = ret.username;
            }
            this.save_session( this.session_id, this.session_key, this.user_id, this.username );
            
            //const key = await this.getPushKey();
            
            //this.subscribeToPush( key );
        }
        this.is_logging_in = false;
        //console.log(ret);
        return ret;
    };
    
    /**
     * Trigger a password reset email with username/email address
     */
    sendResetEmail = async ( user ) => {
        if( this.logging ) console.log('Attempting password reset email');
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'resetpass',
        };
        
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer',
                body: JSON.stringify({
                    username: user
                })
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
    
        return ret;
    };
    
    /**
     * Trigger a password reset
     */
    resetPassword = async ( user, pass, key ) => {
        if( this.logging ) console.log('Attempting password reset');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'resetpass_final',
        };
        
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer',
                body: JSON.stringify({
                    username: user,
                    password: pass,
                    key: key
                })
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
    
        //login the user
        if( ret.success && ret.session ){
            if( this.logging ) console.log('Password reset success! Saving session.');
            this.session_id = ret.session.s_id;
            this.session_key = ret.session.s_key;
            if( ret.session.user_id ){
                this.user_id = ret.session.user_id;
            }
            if( ret.username ){
                this.username = ret.username;
            }
            this.save_session( this.session_id, this.session_key, this.user_id, this.username );
    
            //const key = await this.getPushKey();
            //this.subscribeToPush( key );
        }
    
        return ret;
    };
    
    /**
     * Change the currently logged in user's password
     */
    changePassword = async ( newpass ) => {
        if( this.logging ) console.log('Attempting password change');
        if( !this.isLoggedIn || null == this.user_id || 'null' === this.user_id ){
            return {success:false,code:'not_logged_in',message:"You are not logged in."};
        }
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'change_password',
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const bodyParams = {
            newpass: newpass
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+this.session_id,
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer',
                body: JSON.stringify(bodyParams),
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
    
        return ret;
    };
    
    // getPushKey = async () => {
    //     const response = await fetch(
    //         this.url + "/builders-app/v1/pushkey",
    //         {
    //             cache: 'no-store',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             method: 'get',
    //             redirect: 'follow',
    //             referrer: 'no-referrer'
    //         }
    //     );
    //
    //     let ret = await response.json();
    //
    //     if( this.logging ) console.log(ret);
    //
    //     if( ret.key && '' !== ret.key ){
    //         wbStorage.set_item( "pushKey", ret.key );
    //         this.push_key = ret.key;
    //     }
    //     return this.push_key;
    // }
    
    // subscribeToPush = async ( key ) => {
    //     const subscription = await wbPush.subscribeUser( key );
    //
    //     if( this.logging ) console.log('Push handler registered:');
    //     if( this.logging ) console.log( JSON.stringify(subscription) );
    //     //send to our server
    //
    //     const response = await fetch(
    //         this.url + "/builders-app/v1/registerpush",
    //         {
    //             cache: 'no-store',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: 'post',
    //             redirect: 'follow',
    //             referrer: 'no-referrer',
    //             body: JSON.stringify({
    //                 push: subscription
    //             })
    //         }
    //     );
    //
    //     let ret = await response.json();
    //
    //     if( ret.success ){
    //         if( this.logging ) console.log('Successfully registered for push notifications');
    //     } else {
    //         console.log( ret );
    //     }
    // }
    //
    // unSubscribeToPush = async () => {
    //     await wbPush.unSubscribe();
    // }
    
    /**
     * Validate a session to ensure it's not expired
     *
     * NOTE: untested
     */
    validate_session = async () => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'ping',
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        
        let valid = false;
        if( ret.success && ret.session ){
            valid = true;
        }
        
        if( !valid ){
            if( this.logging ) console.log('session invalid - removing localstorage');
            this.logout();
        }
        
        return valid;
    };
    
    // /**
    //  * Get the current user's profile details
    //  */
    // getProfile = async ( force ) => {
    //     if( !this.isLoggedIn || null == this.user_id || 'null' === this.user_id ){
    //         return {success:false,code:'not_logged_in',message:"You are not logged in."};
    //     }
    //
    //     if( typeof force == "undefined" ){
    //         var force = false;
    //     }
    //
    //     let savedProfile = null;
    //     if( !force ){
    //         if( typeof window != "undefined" ){
    //             savedProfile = sessionStorage.getItem('user_profile');
    //             if( savedProfile ){
    //                 try{
    //                     let data = JSON.parse(savedProfile);
    //                     const retur_id = data.id ?? -1;
    //                     if( retur_id == this.user_id ){
    //                         this.profileLoaded( data );
    //                         return data;
    //                     }
    //                 } catch(e) {
    //                     console.log('JSON decode of cached profile failed - proceeding to fetch from server.', savedProfile);
    //                 }
    //             }
    //         }
    //     }
    //
    //     const response = await fetch(
    //         this.url + "/wp/v2/users/me",
    //         {
    //             cache: 'default',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: 'get',
    //             redirect: 'follow',
    //             referrer: 'no-referrer'
    //         }
    //     ).catch(this._handleOffline);
    //
    //     let ret = response;
    //     if( typeof ret.json == "function" ){
    //         ret = await response.json();
    //     }
    //     this.check_session(ret);
    //
    //     //cache profile (it doesn't change often)
    //     const retur_id = ret.id ?? -1;
    //     if( retur_id == this.user_id ){
    //         if( typeof window != "undefined" ){
    //             sessionStorage.setItem('user_profile', JSON.stringify(ret));
    //         }
    //         this.profileLoaded( ret );
    //     }
    //
    //     return ret;
    // };
    //
    // /**
    //  * Updates the current user's profile
    //  */
    // updateProfile = async ( request ) => {
    //     let body = request;
    //     let method = 'post';
    //
    //     const response = await fetch(
    //         this.url + "/wp/v2/users/me",
    //         {
    //             cache: 'no-store',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: method,
    //             redirect: 'follow',
    //             referrer: 'no-referrer',
    //             body: JSON.stringify(body)
    //         }
    //     ).catch(this._handleOffline);
    //
    //     let ret = response;
    //     if( typeof ret.json == "function" ){
    //         ret = await response.json();
    //     }
    //     this.check_session(ret);
    //
    //     if( typeof window != "undefined" ){
    //         sessionStorage.removeItem('user_profile');
    //         sessionStorage.removeItem('user_cache');
    //     }
    //
    //     return ret;
    // };
    //
    // /**
    //  * Get the user's profile details
    //  */
    // getUser = async ( user_id ) => {
    //     if( !this.isLoggedIn || null == this.user_id || 'null' === this.user_id ){
    //         return {success:false,code:'not_logged_in',message:"You are not logged in."};
    //     }
    //
    //     const response = await fetch(
    //         this.url + "/wp/v2/users/"+user_id,
    //         {
    //             cache: 'default',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: 'get',
    //             redirect: 'follow',
    //             referrer: 'no-referrer'
    //         }
    //     ).catch(this._handleOffline);
    //
    //     let ret = response;
    //     if( typeof ret.json == "function" ){
    //         ret = await response.json();
    //     }
    //     this.check_session(ret);
    //
    //     return ret;
    // };
    //
    // /**
    //  * Updates the current user's profile
    //  */
    // updateUser = async ( user_id, request ) => {
    //     let body = request;
    //     let method = 'post';
    //
    //     const response = await fetch(
    //         this.url + "/wp/v2/users/"+user_id,
    //         {
    //             cache: 'no-store',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: method,
    //             redirect: 'follow',
    //             referrer: 'no-referrer',
    //             body: JSON.stringify(body)
    //         }
    //     ).catch(this._handleOffline);
    //
    //     let ret = response;
    //     if( typeof ret.json == "function" ){
    //         ret = await response.json();
    //     }
    //     this.check_session(ret);
    //
    //     if( typeof window != "undefined" ){
    //         sessionStorage.removeItem('user_profile');
    //         sessionStorage.removeItem('user_cache');
    //     }
    //
    //     return ret;
    // };
    //
    /**
     * Creates a new user account
     */
    insertUser = async ( email, password, level ) => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'insert_user',
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const bodyParams = {
            insert_user: email,
            insert_pass: password,
            insert_level: level ?? 3,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer',
                body: JSON.stringify(bodyParams)
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
    
        if( typeof window != "undefined" ){
            sessionStorage.removeItem('user_profile');
            sessionStorage.removeItem('user_cache');
        }
    
        return ret;
    };
    
    
    // /**
    //  * Gets all messages/notifications for this user
    //  */
    // getNotifications = async () => {
    //     const response = await fetch(
    //         this.url + "/wp/v2/messages?per_page=20",
    //         {
    //             cache: 'default',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: 'get',
    //             redirect: 'follow',
    //             referrer: 'no-referrer'
    //         }
    //     );
    //
    //     let ret = await response.json();
    //     this.check_session(ret);
    //
    //     return ret;
    // }
    //
    // /**
    //  * Update a messages/notifications to mark it dismissed
    //  */
    // dismissNotification = async ( msgid ) => {
    //     let body = {
    //         dismissed: "on",
    //         id: msgid
    //     };
    //     let method = 'post';
    //     const response = await fetch(
    //         this.url + "/wp/v2/messages/"+msgid,
    //         {
    //             cache: 'no-store',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Bearer '+this.session_id,
    //             },
    //             method: method,
    //             redirect: 'follow',
    //             referrer: 'no-referrer',
    //             body: JSON.stringify(body)
    //         }
    //     );
    //
    //     let ret = await response.json();
    //     this.check_session(ret);
    //
    //     return ret;
    // }
    
    /**
     * Fetch a list of all users
     */
    getUsers = async () => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_users',
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
    
        return ret;
    };
    
    /**
     * Fetch a list of Fields for the Application Form
     */
    getFields = async () => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_fields',
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
    
        return ret;
    };
    
    create_application = async ( company, email ) => {
        if( this.logging ) console.log('Attempting Application create');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'insert_application',
            
        };
        const bodyParams = {
            company: company,
            email: email,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                body: JSON.stringify(bodyParams),
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    update_application = async ( id, pwd, fields ) => {
        if( this.logging ) console.log('Attempting Application update');
        
        this.app_id = id;
        this.app_pwd = pwd;
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'update_application',
            app_id: id,
            app_pwd: pwd
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                body: JSON.stringify(fields),
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    admin_update_application = async ( id, fields ) => {
        if( this.logging ) console.log('Attempting Application update');
        
        this.app_id = id;
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'update_application',
            app_id: id,
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                body: JSON.stringify(fields),
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    get_application = async ( id, pwd ) => {
        if( this.logging ) console.log('Attempting Application lookup');
        
        this.app_id = id;
        this.app_pwd = pwd;
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_application',
            app_id: id,
            app_pwd: pwd
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    admin_get_application = async ( id ) => {
        if( this.logging ) console.log('Attempting Application lookup');
        
        this.app_id = id;
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_application',
            app_id: id,
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    /**
     * Fetch a list of all Applications (admin)
     *
     * @param status (string) The status (key) to search for. See 'get_applications' server-side
     * @param page (int) Results are paginated, current page (starts at 0).
     */
    getApplications = async ( status, page ) => {
        if( typeof page == "undefined" ){
            page = 0;
        }
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_applications',
            s_id: this.session_id,
            s_key: this.session_key,
            status: status,
            page: page
        };
    
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
    
        return ret;
    };
    
    /**
     * Fetch a list of all possible Application statuses
     */
    getStatuses = async ( force ) => {
        if( typeof force == "undefined" ){
            var force = false;
        }
        
        let savedStatuses = null;
        if( !force ){
            if( typeof window != "undefined" ){
                savedStatuses = sessionStorage.getItem('appl_statuses');
                if( savedStatuses ){
                    try{
                        let ret = JSON.parse(savedStatuses);
                        return ret;
                    } catch(e) {
                        console.log('JSON decode of cached statuses failed - proceeding to fetch from server.', savedStatuses);
                    }
                }
            }
        }
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_statuses'
        };
        
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        
        //cache statuses (they don't change often)
        if( ret.success && typeof window != "undefined" ){
            sessionStorage.setItem('appl_statuses', JSON.stringify(ret));
        }
        
        return ret;
    };
    
    lookupBusiness = async ( business_name ) => {
        if( this.logging ) console.log('Attempting Application lookup');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'lookup_abn',
            name_lookup: business_name,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    lookupAbn = async ( abn_no ) => {
        if( this.logging ) console.log('Attempting Application lookup');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'lookup_abn',
            abn_lookup: abn_no,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    /**
     * Fetch the Credit Card encryption key
     */
    getEncryptionKey = async () => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'get_encryption_key',
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'default',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'get',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
    
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
    
        return ret;
    };
    
    /**
     * Submit an Encrypted Credit Card and get the Token
     */
    getCreditCardToken = async ( fName, lName, cardNum, expiryMth, expiryYr, cvn ) => {
        if( this.logging ) console.log('Attempting Application update');
        const requestBody = {
            title: '',
            cardholder_fname: fName,
            cardholder_lname: lName,
            txtCardName: fName + " " + lName,
            "EWAY_CARDNUMBER": cardNum,
            ddlCardExpiryMonth: expiryMth,
            ddlCardExpiryYear: expiryYr,
            "EWAY_CARDCVN": cvn,
        };
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'process_credit_card',
            app_id: this.app_id,
            app_pwd: this.app_pwd,
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                body: JSON.stringify(requestBody),
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    submitApplication = async ( id, pwd ) => {
        if( this.logging ) console.log('Attempting Application submit');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'submit_application',
            app_id: id,
            app_pwd: pwd
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    cancelApplication = async ( id, pwd ) => {
        if( this.logging ) console.log('Attempting Application submit');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'cancel_application',
            app_id: id,
            app_pwd: pwd
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    admin_update_status = async ( id, status ) => {
        if( this.logging ) console.log('Attempting Application approval (admin)');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'admin_update_status',
            app_id: id,
            new_status: status,
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    admin_create_debtor = async ( id ) => {
        if( this.logging ) console.log('Attempting Application debtor creation (admin)');
        
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'admin_create_debtor',
            app_id: id,
            s_id: this.session_id,
            s_key: this.session_key,
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer'
            }
        ).catch(this._handleOffline);
        
        let ret = response;
        if( typeof ret.json == "function" ){
            ret = await response.json();
        }
        this.check_session(ret);
        //console.log(ret);
        return ret;
    };
    
    /**
     * Uploads an image to the server. Returns the file ID.
     *
     * @param file (base64string) File data.
     * @param name (string) Filename.
     */
    uploadFile = async ( file, name ) => {
        const urlParams = {
            wb_key: this.apikey,
            call_action: 'upload_file',
            filename: name,
            file: file
        };
        const response = await fetch(
            this.url + '?' + this._encodeToURL(urlParams),
            {
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'post',
                redirect: 'follow',
                referrer: 'no-referrer',
                body: JSON.stringify(postData)
            }
        );
        
        let ret = await response.json();
        this.check_session(ret);
        
        return ret;
    };
    
    getUserProfile = () => {
        return {
            user_id: this.user_id,
            username: this.username
        };
    };
    
    _handleOffline = (err) => {
        //console.log('Fetch failed: ', err);
        const errorOb = {
            error: 'I can\'t reach the server. Please try again.',
            error_code: 'offline',
            success: false,
        };
        if( typeof navigator != "undefined" ){
            if( !navigator.onLine ){
                errorOb.error = "You are offline, please check your connection and try again.";
            }
        }
        return errorOb;
    };
    
    _encodeToURL = (data) => {
        return Object
          .keys(data)
          .map(value => `${value}=${encodeURIComponent(data[value])}`)
          .join('&');
     };
    
    /*
	 * checks localstorage and restores previous session
	 */
	restoreSession(){
		if( this.logging ) console.log('attempting to restore session');
		let session_id = wbStorage.get_item("sessionID");
		if( null != session_id && 'null' !== session_id ){
			if( this.logging ) console.log('session ID restored: '+session_id);
			this.session_id = session_id;
		}
        let session_key = wbStorage.get_item("sessionKey");
		if( null != session_key && 'null' !== session_key ){
			if( this.logging ) console.log('session Key restored: '+session_key);
			this.session_key = session_key;
		}
		let user_id = wbStorage.get_item("userID");
		if( user_id !== null ){
			if( this.logging ) console.log('session user_id restored: '+user_id);
			this.user_id = user_id;
		}
		let username = wbStorage.get_item("username");
		if( username !== null ){
			if( this.logging ) console.log('session username restored: '+username);
			this.username = username;
		}
        
        //TODO: maybe fire an event here or something
        this.profileLoaded( {
            user_id: this.user_id,
            username:this.username
        } );
        
		// let push_key = wbStorage.get_item("pushKey");
		// if( push_key !== null ){
		// 	if( this.logging ) console.log('push_key restored: '+push_key);
		// 	this.push_key = push_key;
        //
        //     //TODO: maybe fire an event here or something
		// } else {
        //     this.getPushKey();
        // }
	}
    
    /*
	 * saves the current session to localstorage
	 */
	save_session( session, key, user_id, username ){
		wbStorage.set_item( "sessionID", session );
    	wbStorage.set_item( "sessionKey", key );
		wbStorage.set_item( "userID", user_id );
		wbStorage.set_item( "username", username );
	}
    
    /*
     * To be called with the result of every Ajax request - checks to ensure that we are still logged in
     *  If not, triggers this.logout()
     */
    check_session( data ){
        let result = true;
        let invalidCodes = [
            'no_session'
        ];
        
        console.log("Check session: ",data);
        
        if( typeof data.error_code != "undefined" && invalidCodes.includes(data.error_code) ){
            //this.logout();
            result = false;
            
            let sessionErrorMsg = (data.error || "Your login session has expired. Please log in again.");
            //this.logout();
            this.sessionError( sessionErrorMsg );
        }
        
        return result;
    }
    
    /*
	 * removes the current session from localstorage
	 */
	logout(){
        if( this.is_logging_in )
            return;
        if( this.logging ) console.log('Logout triggered');
		wbStorage.set_item( "sessionID", null );
		wbStorage.set_item( "userID", null );
		wbStorage.set_item( "username", null );
		wbStorage.set_item( "pushKey", null );
        sessionStorage.clear();
        this.user_id = null;
        this.session_id = null;
        this.session_key = null;
        //this.push_key = null;
        
        //this.unSubscribeToPush();
	}
    
    /*
	 * Checks whether we are currently logged in (but does not validate session)
	 */
    isLoggedIn(){
        //if( this.logging ) console.log('Checking for presence of session token: '+this.session_id);
        return (null != this.session_id && 'null' !== this.session_id);
    }
    
    /*
     * Passes us the setState function of the primary controller class, allowing us to
     * trigger notifications when a user's session expires.
     */
    passControllerErrorFunction( errorFunction ){
        this.sessionError = errorFunction;
    }
    
    /*
     * Passes us the setState function of the primary controller class, allowing us to
     * trigger notifications when a user's profile is loaded.
     */
    passControllerProfileLoadedFunction( loadedFunction ){
        this.profileLoaded = loadedFunction;
    }
}

const WbSession = createContext(new Session());

export default WbSession;
